import { useFormState } from 'react-final-form';

import { ConditionalCheckmark } from '~/components/common/ConditionalCheckmark/ConditionalCheckmark';
import { peopleTerm } from '~/util/textUtils';

import { ServiceCustomerField } from '../../components/ServiceCustomerField/ServiceCustomerField';
import { SummarySection } from '../../components/SummarySection/SummarySection';
import Styled from '../../components/SummarySection/SummarySection.styles';
import { useInquiryValues } from '../../context/InquiryContext';
import { LoadedInquiryValues } from '../../context/types';
import { SummaryComponent, InquiryFormValues } from '../../types';
import { getHed, getInstructions } from './CustomerCountQuestion';

export const CustomerCountSummary: SummaryComponent = () => {
  const { storefront } = useInquiryValues() as LoadedInquiryValues;
  const { values } = useFormState<InquiryFormValues>();

  const renderView = () => {
    const numPeople = values.serviceCustomerCount;
    const formattedPeople = numPeople ? peopleTerm(numPeople) : 'No selection';
    return (
      <Styled.ViewSection>
        {formattedPeople}
        <ConditionalCheckmark visible={Boolean(values.flexibleOnServiceCustomerCount)}>
          This may change
        </ConditionalCheckmark>
      </Styled.ViewSection>
    );
  };
  const renderEdit = () => {
    return (
      <Styled.EditSection>
        <p>{getInstructions({ storefront })}</p>
        <ServiceCustomerField />
      </Styled.EditSection>
    );
  };

  return (
    <SummarySection hed={getHed({ storefront })} view={renderView()} edit={renderEdit()} required />
  );
};
